export const product = {
  title: 'El Protocolo de Inflamación Silenciosa',
  price: '$6.39',
  originalPrice: '$27.00',
  currency: 'USD',
  ctaLabel: '¡SÍ! QUIERO ELIMINAR MI DOLOR AHORA',
  checkoutUrl: 'https://vidasimplelab.com/cart/45817623216175:1',
  mockup:
    'https://cdn.magicpatterns.com/uploads/3wcxA8VbfiYiGvRJXZSybC/el_protocolo_de_la_inchazon_silencioza.png',
}

export const failedAttempts = [
  {
    title: 'Los antiinflamatorios comunes',
    text: 'Solo apagan la alarma, pero dejan que el incendio siga consumiendo sus articulaciones.',
  },
  {
    title: 'Los ejercicios genéricos de gimnasio',
    text: 'A menudo son demasiado agresivos y terminan causando más micro-desgarros.',
  },
  {
    title: 'Las dietas “saludables” tradicionales',
    text: 'Incluyen alimentos que para una mujer de 65 años son auténtica gasolina para la inflamación.',
  },
]

export const deliverables = [
  {
    name: 'El eBook Principal',
    text: 'El Protocolo de Inflamación Silenciosa, la guía completa.',
  },
  {
    name: 'El Método de 3 Minutos',
    text: 'La secuencia exacta de micro-movimientos matutinos.',
  },
  {
    name: 'La Lista Negra de la Despensa',
    text: 'Qué alimentos tirar hoy mismo para bajar el dolor.',
  },
  {
    name: 'Plan de Rescate de 7 Días',
    text: 'Su hoja de ruta paso a paso para la libertad total.',
  },
  {
    name: 'Guía de Suplementos',
    text: 'Los 5 aliados naturales que realmente funcionan.',
  },
]

export const forYou = [
  'Mujeres de 65 años o más que sienten rigidez extrema al despertar.',
  'Personas que han dejado de viajar o jugar con sus nietos debido al dolor.',
  'Quienes buscan una solución natural para no depender de la farmacia.',
  'Mujeres que se sienten “oxidadas” a pesar de intentar mantenerse activas.',
]

export const notForYou = [
  'Personas que buscan una “pastilla mágica” sin cambiar sus hábitos alimenticios.',
  'Quienes no están dispuestos a dedicar 3 minutos cada mañana a su salud.',
  'Casos médicos que requieran intervención quirúrgica inmediata por trauma severo.',
]

export const steps = [
  {
    name: 'Limpie',
    text: 'Elimine los 3 alimentos incendiarios de su cocina.',
  },
  {
    name: 'Active',
    text: 'Realice la secuencia de 3 minutos antes de salir de la cama.',
  },
  {
    name: 'Recupere',
    text: 'Siga el plan de 7 días y documente cómo vuelve su flexibilidad.',
  },
]

export const faqs = [
  {
    question: '¿Es difícil de leer?',
    answer:
      'No, el texto es grande y directo, diseñado para una lectura cómoda.',
  },
  {
    question: '¿Necesito equipo especial?',
    answer: 'Ninguno. Solo su cama y comida real de supermercado.',
  },
  {
    question: '¿Qué pasa si tengo prótesis?',
    answer:
      'El método es seguro y ayuda a mejorar la circulación alrededor de las áreas operadas.',
  },
]
